// extracted by mini-css-extract-plugin
module.exports = {"form-card-actions":"actions-menu_form-card-actions__2J-QL","form-more-actions":"actions-menu_form-more-actions__PaMeD"};